/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booster_Sheet_TitleInputs */

const en_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosting packs`)
};

const ar_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزم التعزيز`)
};

const de_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boost-Pakete`)
};

const es_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs de boost`)
};

const fr_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs de boost`)
};

const it_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetti boost`)
};

const ja_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブーストパック`)
};

const ko_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부스트 패키지`)
};

const pt_br_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes de boost`)
};

const ru_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Буст-пакеты`)
};

const th_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็คบูสต์`)
};

const tr_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takviye paketleri`)
};

const zh_cn_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加速礼包`)
};

const zh_tw_booster_sheet_title = /** @type {(inputs: Booster_Sheet_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加速禮包`)
};

/**
* | output |
* | --- |
* | "Boosting packs" |
*
* @param {Booster_Sheet_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const booster_sheet_title = /** @type {((inputs?: Booster_Sheet_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booster_Sheet_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booster_sheet_title(inputs)
	if (locale === "ar") return ar_booster_sheet_title(inputs)
	if (locale === "de") return de_booster_sheet_title(inputs)
	if (locale === "es") return es_booster_sheet_title(inputs)
	if (locale === "fr") return fr_booster_sheet_title(inputs)
	if (locale === "it") return it_booster_sheet_title(inputs)
	if (locale === "ja") return ja_booster_sheet_title(inputs)
	if (locale === "ko") return ko_booster_sheet_title(inputs)
	if (locale === "pt_br") return pt_br_booster_sheet_title(inputs)
	if (locale === "ru") return ru_booster_sheet_title(inputs)
	if (locale === "th") return th_booster_sheet_title(inputs)
	if (locale === "tr") return tr_booster_sheet_title(inputs)
	if (locale === "zh_cn") return zh_cn_booster_sheet_title(inputs)
	return zh_tw_booster_sheet_title(inputs)
});